import Web3 from 'web3';
import { Provider, Accounts } from '@haloplatform/halo.js';

var state = {
  web3: {
    address: null,
    coinbase: null,
    instance: () => ({
      web3: {}
    }),
    isInjected: false,
    networkId: null,
    isLocal: false,
    balance: null,
    isUnlocked: false,
    isConnected: false
  }
};

const NETWORKS = {
  '1': 'Eth - Main Net',
  '2': 'Eth - Deprecated Morden test network',
  '3': 'Eth - Ropsten test network',
  '4': 'Eth - Rinkeby test network',
  '42': 'Eth - Kovan test network',
  '4447': 'Eth - Truffle Develop Network',
  '5777': 'Eth - Ganache Blockchain',
  '425672638': 'Halo - QA Network',
  '4256338638': 'Halo - Developer Network',
  '42566246638': 'Halo - Main Network',
  '42568378638': 'Halo - Test Network'
};
const APPROVED_NETWORK_ID = '5777';

var getters = {
  address: state => state.web3.address,
  coinbase: state => state.web3.coinbase,
  instance: state => state.web3.instance,
  isInjected: state => state.web3.isInjected,
  networkId: state => state.web3.networkId,
  isLocal: state => state.web3.isLocal,
  balance: state => state.web3.balance,
  isUnlocked: state => state.web3.isUnlocked,
  isApprovedNetwork: state => state.web3.networkId && state.web3.networkId !== '' && state.web3.networkId === APPROVED_NETWORK_ID,
  networkName: state => state.web3.networkId && NETWORKS[state.web3.networkId],
  filter: state => state.web3.instance().eth.filter,
  reset: state => state.web3.instance().reset,
  sha3: state => state.web3.instance().sha3,
  contract: state => state.web3.instance().eth.contract,
  isConnected: state => state.web3.isConnected
};

var mutations = {
  setInjected(state, payload) {
    state.web3.isInjected = payload;
  },

  setInstance(state, payload) {
    state.web3.instance = payload;
  },

  setLocal(state, payload) {
    state.web3.isLocal = payload;
  },

  setNetworkId(state, payload) {
    state.web3.networkId = payload;
  },

  setCoinbase(state, payload) {
    state.web3.coinbase = payload;
  },

  setAddress(state, payload) {
    state.web3.address = payload;
  },

  setBalance(state, payload) {
    state.web3.balance = payload;
  },

  setUnlock(state, payload) {
    state.web3.isUnlocked = payload;
  },

  setConnected(state, payload) {
    state.web3.isConnected = payload;
  }

};

const sleep = (ms = 1000) => new Promise((resolve, reject) => setTimeout(resolve, ms));

var actions = {
  connectToWeb3: ({
    commit
  }) => new Promise((resolve, reject) => {
    const web3 = new Web3(new Provider());
    commit('setInjected', web3.isConnected());
    commit('setInstance', () => web3);
    commit('setLocal', false);
    resolve(web3);
  }),
  getBlockchainNetworkId: ({
    commit,
    state
  }) => new Promise((resolve, reject) => {
    state.web3.instance().version.getNetwork((err, networkId) => {
      if (err) {
        reject(err);
      } else {
        if (state.web3.networkId !== networkId) commit('setNetworkId', networkId);
        resolve(networkId);
      }
    });
  }),
  getCoinbase: ({
    commit,
    state
  }) => new Promise((resolve, reject) => {
    state.web3.instance().eth.getCoinbase((err, coinbase) => {
      if (err) {
        if (state.web3.address) {
          commit('setCoinbase', state.web3.address);
          resolve(state.web3.address);
        }

        reject(err);
      } else {
        if (state.web3.coinbase !== coinbase) commit('setCoinbase', coinbase || state.web3.address);
        resolve(coinbase);
      }
    });
  }),
  getBalance: ({
    commit,
    state
  }) => new Promise((resolve, reject) => {
    const coinbase = state.web3.coinbase;

    if (!coinbase) {
      return resolve('0');
    }

    state.web3.instance().eth.getBalance(state.web3.coinbase, (err, result) => {
      if (err) {
        reject(err);
      } else {
        const balance = state.web3.instance().fromWei(result.toString(10), 'ether');
        if (state.web3.balance !== balance) commit('setBalance', balance);
        resolve(balance);
      }
    });
  }),

  checkUnlock() {
    return Accounts.isUnlocked();
  },

  async monitorWeb3({
    state,
    dispatch,
    commit
  }) {
    // if (state.web3.isLocal || !state.web3.instance()) {
    //   return
    // }
    while (true) {
      await sleep(1000);

      try {
        // refresh coinbase
        await dispatch('getBlockchainNetworkId');
        const address = await dispatch('getCoinbase');
        if (address !== state.web3.address) commit('setAddress', address);
      } catch (err) {
        console.log('get coinbase error:', err);
      }

      try {
        await dispatch('getBalance');
      } catch (err) {
        console.log('get balance error:', err);
      }

      const isUnlocked = await dispatch('checkUnlock');
      if (isUnlocked !== state.web3.isUnlocked) commit('setUnlock', isUnlocked);
      const isConnected = state.web3.instance().isConnected();
      if (isConnected !== state.web3.isConnected) commit('setConnected', isConnected);
    }
  },

  async init({
    dispatch,
    commit,
    state
  }) {
    await dispatch('connectToWeb3');
    await dispatch('getBlockchainNetworkId');

    try {
      commit('setAddress', (await dispatch('getCoinbase')));
    } catch (err) {
      console.log('get coinbase error:', err);
    }

    try {
      await dispatch('getBalance');
    } catch (err) {
      console.log('get balance error:', err);
    }

    commit('setUnlock', (await dispatch('checkUnlock')));
    commit('setConnected', state.web3.instance().isConnected());
    dispatch('monitorWeb3');
  }

};

var index = ((store, moduleName = 'WebThree') => {
  store.registerModule(moduleName, {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
  });
  store.dispatch(`${moduleName}/init`);
});

export default index;
